import React, { Component } from 'react'
import Signin from '../Signin'
import Loader from 'react-loader-spinner'
import { signOut,fireStore } from '../../firebase'
import DealForm from './DealForm'
import VendorStats from './VendorStats'
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar'
import Redeem from './Redeem'
import Directory from '../admin/directory.screen';
import { observer } from 'mobx-react';

const VendorPage = observer( class VendorPage extends Component {
  constructor(){
    super()
    this.mongo = process.env.REACT_APP_MONGO
    this.state = {
      deal: false,
      stats: true,
      redeem: false,
      directory: false,
      vendor: null
    }

    this.togglePage = this.togglePage.bind(this)
  }

  componentDidMount() {
    let { myStores } = this.props;
    let { mainStore } = myStores;

    mainStore.getListings();

  }

  togglePage(page){
    let deal,stats,redeem, directory = false
    switch(page){
      case "deal":
        deal = true
        stats = false
        redeem = false
        directory = false
      break;
      case "stats":
        deal = false
        stats = true
        redeem = false
        directory = false
      break;
      case "redeem":
        deal = false
        stats = false
        redeem = true
        directory = false
      break;
      case 'directory':
        deal = false
        stats = false
        redeem = false
        directory = true
      break;

    }
    this.setState({deal,stats,redeem, directory})
  }

  render() {
    let { myStores } = this.props;
    let { mainStore } = myStores;
    return (
        <div className='container' style={styles.container}>
        <div style={{fontSize: 20, marginBottom: 10}}>
        <AppBar position="sticky" width="inherit" color="default">
            <Toolbar>
                 <Typography variant='title'
                             color='inherit'
                             style={{
                              fontSize: 15,
                              marginLeft:20
                             }}
                             onClick={()=>this.togglePage('deal')}
                             role='button'
                 >Event Form
                 </Typography>
                 <Typography variant='title'
                             color='inherit'
                             style={{
                              fontSize: 15,
                              marginLeft:20
                             }}
                             onClick={()=>this.togglePage('stats')}
                             role='button'
                 >Stats
                 </Typography>

                 {

                   mainStore.isMember ?

                     <Typography variant='title'
                                 color='inherit'
                                 style={{
                                  fontSize: 15,
                                  marginLeft:20
                                 }}
                                 onClick={()=>this.togglePage('directory')}
                                 role='button'
                     >Directory
                     </Typography>

                  : null

                 }

                 <Typography variant='title'
                             color='inherit'
                             style={{
                              fontSize: 15,
                              marginLeft:20,
                              right: 20
                             }}
                             onClick={()=> mainStore.signOut()}
                             role='button'
                 >Logout
                 </Typography>
              </Toolbar>
          </AppBar>
          </div>
          {
            this.state.deal
              ? <DealForm { ...this.props } />
              : null
          }
          {
            this.state.stats
              ? <VendorStats { ...this.props }  />
              : null
          }
          {
            this.state.redeem
              ? <Redeem  uid={this.props.authUser.uid} />
              : null
          }
          {
            this.state.directory ?
              <Directory { ...this.props } />
            : null
          }

        </div>
    )

  }
})

const styles = {
  container: {
    marginBottom: 100,
    marginTop: 100
  }
}
/*
this is another link if needed

<Typography variant='title'
                             color='inherit'
                             style={{
                              fontSize: 15,
                              marginLeft:20
                             }}
                             onClick={()=>this.togglePage('redeem')}
                             role='button'
                 >Collect Redemptions
                 </Typography>
*/

export default VendorPage



// WEBPACK FOOTER //
// ./src/components/vendor/VendorPage.js